import seoConfig from "@/config/seo";

function getSeoEntry(vm) {
  const { seoKey } = vm.$options;
  if (seoKey && seoConfig.pages[seoKey]) {
    return seoConfig.pages[seoKey];
  }

  const { title } = vm.$options;
  if (title) {
    return {
      title: typeof title === "function" ? title.call(vm) : title,
      description: seoConfig.default.description,
    };
  }

  return seoConfig.default;
}

function upsertDescriptionMetaTag(description) {
  let metaDescription = document.querySelector('meta[name="description"]');

  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.setAttribute("name", "description");
    document.head.appendChild(metaDescription);
  }

  metaDescription.setAttribute("content", description);
}

export default {
  created() {
    const seoEntry = getSeoEntry(this);

    if (seoEntry.title) {
      document.title = seoEntry.title;
    }

    if (seoEntry.description) {
      upsertDescriptionMetaTag(seoEntry.description);
    }
  },
};
